import React, { Fragment, useContext, useRef } from 'react';
import { Btn } from '../../../../AbstractElements';
import { Cancel, Print } from '../../../../Constant';
import CartContext from '../../../../_helper/Ecommerce/Cart';
import ProductContext from '../../../../_helper/Ecommerce/Product';
import ItemDescription from './ItemDescription';
import { Col } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { Link, useNavigate } from 'react-router-dom';
import CustomizerContext from '../../../../_helper/Customizer';

const PrintComponent = ({rowData, data}) => {
    const { layoutURL } = useContext(CustomizerContext);
    const componentRef = useRef();
    const { cart } = useContext(CartContext);
    const { symbol } = useContext(ProductContext);
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(`${process.env.PUBLIC_URL}/checkout/:layout`, { state: { data , rowData}})
    }
    return (
        <Fragment>
            <ItemDescription ref={componentRef} cart={cart} symbol={symbol}  rowData={rowData} data={data}/>
            <Col sm="12" className="text-center my-3">
                <Btn attrBtn={{ color: 'primary', className: 'me-2', onClick: handlePrint }}>
                    {Print}
                </Btn>
                {/* <Link > */}
                    <Btn attrBtn={{ color: 'secondary' ,onClick: () =>
                navigate(`/patientinfo/payment`, { state: { data , rowData} }) }}>{"Back"}</Btn>
                {/* </Link> */}
            </Col>
        </Fragment>
    );
};

export default PrintComponent;